import sudokuAdapter from './sudokuAdapter';

const registry = {
  sudoku: sudokuAdapter,
};

export const getPuzzleAdapter = (slug) => registry[slug] || null;

export const supportedPuzzleSlugs = Object.keys(registry);
